var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider_module"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.options}},_vm._l((_vm.sliders),function(slider,index){return _c('swiper-slide',{key:index,class:_vm.id + '_' + index})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }